export default __webpack_public_path__ + "static/media/rambo_01-1.544c61d3.PNG";